import { render, staticRenderFns } from "./MobileEngagementSetting.vue?vue&type=template&id=b165c7fe&"
import script from "./MobileEngagementSetting.vue?vue&type=script&lang=js&"
export * from "./MobileEngagementSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports